
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getTestCredits",
      resolverType: "query",
      routePath: "/getTestCredits",
      httpMethod: "POST",
    });
  